import { __decorate } from "tslib";
import { customElement, property } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { watch } from '../../shared/directives/watch.decorator.js';
import { localized } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { dividerStyles } from './divider.styles.js';
let HlxDivider = class HlxDivider extends HelixElement {
    constructor() {
        super(...arguments);
        this.size = 'small';
        this.orientation = 'horizontal';
        this.color = 'weak-1';
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'separator');
    }
    handleVerticalChange() {
        this.setAttribute('aria-orientation', this.orientation);
    }
};
HlxDivider.styles = [componentStyles, dividerStyles];
__decorate([
    property({ type: String, reflect: true })
], HlxDivider.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxDivider.prototype, "orientation", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxDivider.prototype, "color", void 0);
__decorate([
    watch('orientation')
], HlxDivider.prototype, "handleVerticalChange", null);
HlxDivider = __decorate([
    customElement('hlx-divider'),
    localized()
], HlxDivider);
export { HlxDivider };
//# sourceMappingURL=divider.js.map